document.documentElement.classList.remove('no-js');

// Keep collection return-position handling under theme control so a shopper who
// opens a product and then goes Back lands exactly where they left the grid.
try {
  if (document.body?.classList.contains('template-collection') && 'scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
} catch (_) {}

document.addEventListener('DOMContentLoaded', () => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Scroll-aware main header: hide while scrolling down, return immediately on upward intent.
  const smartHeader = document.querySelector('.site-header');
  if (smartHeader) {
    let lastScrollY = Math.max(0, window.scrollY);
    let ticking = false;
    const updateHeader = () => {
      const currentY = Math.max(0, window.scrollY);
      const delta = currentY - lastScrollY;
      const cartIsOpen = document.body.classList.contains('cart-drawer-open');
      if (cartIsOpen || currentY < 72) {
        smartHeader.classList.remove('is-scroll-hidden');
        smartHeader.classList.add('is-scroll-visible');
      } else if (delta > 7) {
        smartHeader.classList.add('is-scroll-hidden');
        smartHeader.classList.remove('is-scroll-visible');
      } else if (delta < -4) {
        smartHeader.classList.remove('is-scroll-hidden');
        smartHeader.classList.add('is-scroll-visible');
      }
      lastScrollY = currentY;
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(updateHeader); }
    }, { passive: true });
    updateHeader();
  }

  // Mobile menu
  const toggle = document.querySelector('[data-menu-toggle]');
  const mobile = document.querySelector('[data-mobile-nav]');
  if (toggle && mobile) {
    toggle.addEventListener('click', () => {
      const open = mobile.classList.toggle('is-open');
      toggle.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    mobile.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
      mobile.classList.remove('is-open');
      toggle.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }));
  }

  // Reveal animation
  const revealEls = [...document.querySelectorAll('[data-reveal]')];
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    }), { threshold: .08, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(el => observer.observe(el));
  } else {
    revealEls.forEach(el => el.classList.add('is-visible'));
  }

  // Safe collection jump: values come from actual Shopify collection objects.
  document.querySelectorAll('[data-collection-jump]').forEach(select => {
    select.addEventListener('change', () => { if (select.value) window.location.assign(select.value); });
  });

  // ---------- Cart drawer ----------
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const cartClose = document.querySelector('[data-cart-close]');
  const cartBody = document.querySelector('[data-cart-drawer-body]');
  const cartFooter = document.querySelector('[data-cart-drawer-footer]');
  const cartSubtotal = document.querySelector('[data-cart-subtotal]');
  const cartSavings = document.querySelector('[data-cart-savings]');
  const cartSavingsAmount = document.querySelector('[data-cart-savings-amount]');
  const cartCountEls = [...document.querySelectorAll('[data-cart-count], [data-cart-drawer-count]')];
  const shippingMeter = document.querySelector('[data-free-shipping-meter]');
  const shippingFill = document.querySelector('[data-free-shipping-fill]');
  const shippingTitle = document.querySelector('[data-free-shipping-title]');
  const shippingNote = document.querySelector('[data-free-shipping-note]');
  const shippingThreshold = parseInt(cartDrawer?.dataset.freeShippingThreshold || '1000', 10) || 1000;
  let cartReturnFocus = null;

  const formatMoney = cents => {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'JOD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, minimumFractionDigits: currency === 'JOD' ? 3 : 2 }).format(cents / 100);
    } catch (e) {
      return `${(cents / 100).toFixed(2)} ${currency}`;
    }
  };

  const setCartSavings = cents => {
    if (!cartSavings) return;
    const value = Math.max(0, Number(cents || 0));
    cartSavings.hidden = value <= 0;
    cartSavings.dataset.cartSavingsCents = String(value);
    if (cartSavingsAmount) cartSavingsAmount.textContent = value > 0 ? formatMoney(value) : '';
  };

  const ajaxCartSavings = cart => (cart?.items || []).reduce((sum, item) => {
    const original = Number(item.original_line_price || 0);
    const finalPrice = Number(item.final_line_price || 0);
    return sum + Math.max(0, original - finalPrice);
  }, 0);

  const refreshLiquidCartSavings = async fallback => {
    setCartSavings(fallback);
    if (!cartSavings) return;
    try {
      const sectionResponse = await fetch(`${root}?section_id=header`, { headers: { Accept: 'text/html' } });
      if (!sectionResponse.ok) return;
      const html = await sectionResponse.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const source = doc.querySelector('[data-cart-savings]');
      if (!source) return;
      setCartSavings(Number(source.dataset.cartSavingsCents || 0));
    } catch (_) {}
  };

  const celebrateAddToCart = () => {
    // Vibration is supported on many Android browsers; unsupported browsers simply skip it.
    try { if (navigator.vibrate) navigator.vibrate([18, 28, 34]); } catch (_) {}
    if (!shippingMeter) return;
    shippingMeter.classList.remove('is-celebrating');
    // Restart the CSS animation even on rapid consecutive additions.
    void shippingMeter.offsetWidth;
    shippingMeter.classList.add('is-celebrating');
    window.setTimeout(() => shippingMeter.classList.remove('is-celebrating'), 760);
  };

  const escapeHtml = value => String(value == null ? '' : value)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');

  const updateFreeShipping = cart => {
    if (!cart || !shippingMeter) return;
    const total = Number(cart.total_price || 0);
    const remaining = Math.max(0, shippingThreshold - total);
    const progress = Math.max(0, Math.min(100, (total / shippingThreshold) * 100));
    if (shippingFill) shippingFill.style.width = `${progress}%`;
    const unlocked = total >= shippingThreshold;
    shippingMeter.classList.toggle('is-unlocked', unlocked);
    if (shippingTitle) shippingTitle.textContent = unlocked ? 'Free shipping unlocked!' : `You're ${formatMoney(remaining)} away`;
    if (shippingNote) shippingNote.textContent = unlocked ? 'Your order qualifies for free shipping.' : 'Spend 10 JOD to get free shipping.';
  };

  const updateCartCountBadges = count => {
    cartCountEls.forEach(el => {
      el.textContent = count;
      if (el.matches('[data-cart-count]')) el.classList.toggle('is-empty', Number(count) === 0);
    });
  };

  const setCartOpen = (open, refresh = true) => {
    if (!cartDrawer || !cartOverlay || !cartToggle) return;
    if (open) {
      cartReturnFocus = document.activeElement;
      document.body.classList.add('cart-drawer-open');
    }
    const header = document.querySelector('.site-header');
    if (open && header) {
      header.classList.remove('is-scroll-hidden');
      header.classList.add('is-scroll-visible');
    }
    const headerBottom = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
    cartDrawer.style.top = `${headerBottom}px`;
    cartDrawer.style.height = `calc(100dvh - ${headerBottom}px)`;
    cartOverlay.style.top = `${headerBottom}px`;
    cartDrawer.classList.toggle('is-open', open);
    cartOverlay.classList.toggle('is-open', open);
    cartDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    cartToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open) {
      document.body.classList.remove('cart-drawer-open');
      if (cartReturnFocus && typeof cartReturnFocus.focus === 'function') cartReturnFocus.focus();
    }
    if (open) {
      if (refresh) refreshCartDrawer();
      window.setTimeout(() => cartClose && cartClose.focus(), 160);
    }
  };

  const refreshCartDrawer = async () => {
    if (!cartBody) return;
    try {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart request failed');
      const cart = await response.json();
      updateCartCountBadges(cart.item_count);
      updateFreeShipping(cart);
      if (cart.item_count === 0) {
        cartBody.innerHTML = '<div class="cart-drawer__empty"><strong>Your cart is empty.</strong><span>Choose your iPhone and find your case.</span></div>';
        setCartSavings(0);
        if (cartFooter) cartFooter.hidden = true;
        return cart;
      }

      cartBody.innerHTML = cart.items.map(item => {
        const image = item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : '';
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<span>${escapeHtml(item.variant_title)}</span>` : '';
        return `<div class="cart-drawer__item" data-cart-line data-cart-key="${escapeHtml(item.key)}">
          <a href="${escapeHtml(item.url)}" class="cart-drawer__image">${image}</a>
          <div class="cart-drawer__item-copy">
            <a href="${escapeHtml(item.url)}" class="cart-drawer__title">${escapeHtml(item.product_title)}</a>
            ${variant}
            <strong>${formatMoney(item.final_line_price)}</strong>
            <div class="cart-drawer__controls">
              <div class="cart-drawer__qty" aria-label="Quantity">
                <button type="button" data-cart-qty-change="-1" aria-label="Decrease quantity">−</button>
                <span>${item.quantity}</span>
                <button type="button" data-cart-qty-change="1" aria-label="Increase quantity">+</button>
              </div>
              <button type="button" class="cart-drawer__remove" data-cart-remove>Remove</button>
            </div>
          </div>
        </div>`;
      }).join('');
      if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
      const fallbackSavings = ajaxCartSavings(cart);
      refreshLiquidCartSavings(fallbackSavings);
      if (cartFooter) cartFooter.hidden = false;
      return cart;
    } catch (e) {
      console.warn(e);
      return null;
    }
  };

  const changeCartLine = async (key, quantity, lineEl) => {
    if (!key) return;
    if (lineEl) lineEl.classList.add('is-updating');
    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
      });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.description || 'Could not update cart');
      }
      await refreshCartDrawer();
    } catch (err) {
      alert(err.message || 'Could not update your cart. Please try again.');
      if (lineEl) lineEl.classList.remove('is-updating');
    }
  };

  if (cartBody) {
    cartBody.addEventListener('click', e => {
      const line = e.target.closest('[data-cart-line]');
      if (!line) return;
      const key = line.dataset.cartKey;
      if (e.target.closest('[data-cart-remove]')) {
        e.preventDefault();
        changeCartLine(key, 0, line);
        return;
      }
      const qtyButton = e.target.closest('[data-cart-qty-change]');
      if (qtyButton) {
        e.preventDefault();
        const current = parseInt(line.querySelector('.cart-drawer__qty span')?.textContent || '1', 10) || 1;
        const delta = parseInt(qtyButton.dataset.cartQtyChange || '0', 10) || 0;
        changeCartLine(key, current + delta, line);
      }
    });
  }

  if (cartToggle) cartToggle.addEventListener('click', () => setCartOpen(!cartDrawer.classList.contains('is-open')));
  if (cartClose) cartClose.addEventListener('click', () => setCartOpen(false));
  if (cartOverlay) cartOverlay.addEventListener('click', () => setCartOpen(false));
  document.addEventListener('keydown', e => {
    if (!cartDrawer || !cartDrawer.classList.contains('is-open')) return;
    if (e.key === 'Escape') { setCartOpen(false); return; }
    if (e.key === 'Tab') {
      const focusable = [...cartDrawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(el => el.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // ---------- Product page ----------
  document.querySelectorAll('[data-product-section]').forEach(section => {
    const idInput = section.querySelector('[data-variant-id-input]') || section.querySelector('[name="id"]');
    const price = section.querySelector('[data-product-price]');
    const currentPrice = section.querySelector('[data-current-price]');
    const comparePrice = section.querySelector('[data-compare-price]');
    const savings = section.querySelector('[data-product-savings]');
    const savingsAmount = section.querySelector('[data-product-savings-amount]');
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const add = section.querySelector('[data-add-to-cart]');
    const form = section.querySelector('form[action*="/cart/add"]');
    const qty = section.querySelector('[data-product-qty]');
    const qtyMinus = section.querySelector('[data-qty-minus]');
    const qtyPlus = section.querySelector('[data-qty-plus]');
    const slider = section.querySelector('[data-product-slider]');
    const slides = [...section.querySelectorAll('[data-media-slide]')];
    const dots = [...section.querySelectorAll('[data-slide-dot]')];
    const thumbs = [...section.querySelectorAll('[data-thumb]')];

    if (qtyMinus && qty) qtyMinus.addEventListener('click', () => { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
    if (qtyPlus && qty) qtyPlus.addEventListener('click', () => { qty.value = (parseInt(qty.value, 10) || 1) + 1; });

    const smoothScrollSliderTo = (targetLeft, duration = 210) => {
      if (!slider) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { slider.scrollLeft = targetLeft; return; }
      const start = slider.scrollLeft;
      const delta = targetLeft - start;
      if (Math.abs(delta) < 2) return;
      const startTime = performance.now();
      const ease = t => 1 - Math.pow(1 - t, 4);
      const frame = now => {
        const t = Math.min(1, (now - startTime) / duration);
        slider.scrollLeft = start + delta * ease(t);
        if (t < 1) requestAnimationFrame(frame);
      };
      requestAnimationFrame(frame);
    };

    const goToMedia = mediaId => {
      const target = slides.find(s => String(s.dataset.mediaId) === String(mediaId));
      if (!target || !slider) return;
      smoothScrollSliderTo(target.offsetLeft, 190);
    };

    const setActiveMedia = mediaId => {
      dots.forEach(dot => dot.classList.toggle('is-active', String(dot.dataset.mediaId) === String(mediaId)));
      thumbs.forEach(thumb => thumb.classList.toggle('is-active', String(thumb.dataset.mediaId) === String(mediaId)));

      // Pause any media that has been swiped out of view.
      section.querySelectorAll('[data-media-slide]').forEach(slide => {
        if (String(slide.dataset.mediaId) === String(mediaId)) return;
        slide.querySelectorAll('video').forEach(video => { if (!video.paused) video.pause(); });
        slide.querySelectorAll('[data-product-external-video]').forEach(wrap => {
          const iframe = wrap.querySelector('iframe');
          const host = wrap.dataset.videoHost;
          try {
            if (host === 'youtube') iframe?.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
            else if (host === 'vimeo') iframe?.contentWindow?.postMessage({ method: 'pause' }, '*');
          } catch (_) {}
          const button = wrap.querySelector('[data-external-video-toggle]');
          if (button) {
            button.classList.remove('is-playing');
            button.setAttribute('aria-pressed', 'false');
            button.setAttribute('aria-label', 'Play video');
          }
        });
      });
    };

    dots.forEach(dot => dot.addEventListener('click', () => goToMedia(dot.dataset.mediaId)));
    thumbs.forEach(thumb => thumb.addEventListener('click', () => goToMedia(thumb.dataset.mediaId)));

    if (slider && slides.length > 1) {
      // Circular swipe gallery: clone the edge slides so a swipe past the last image
      // lands seamlessly back on the first, and vice versa.
      const firstClone = slides[0].cloneNode(true);
      const lastClone = slides[slides.length - 1].cloneNode(true);
      firstClone.dataset.clone = 'first';
      lastClone.dataset.clone = 'last';
      firstClone.setAttribute('aria-hidden', 'true');
      lastClone.setAttribute('aria-hidden', 'true');
      slider.insertBefore(lastClone, slides[0]);
      slider.appendChild(firstClone);

      const allSlides = [...slider.querySelectorAll('[data-media-slide]')];
      let jumping = false;
      let scrollTimer;

      const jumpToIndex = index => {
        const target = allSlides[index];
        if (!target) return;
        jumping = true;
        slider.style.scrollBehavior = 'auto';
        slider.scrollLeft = target.offsetLeft;
        requestAnimationFrame(() => {
          slider.style.scrollBehavior = '';
          jumping = false;
        });
      };

      requestAnimationFrame(() => jumpToIndex(1));

      const settleLoop = () => {
        if (jumping) return;
        const center = slider.scrollLeft + slider.clientWidth / 2;
        let nearestIndex = 0;
        let best = Infinity;
        allSlides.forEach((slide, index) => {
          const distance = Math.abs((slide.offsetLeft + slide.offsetWidth / 2) - center);
          if (distance < best) { best = distance; nearestIndex = index; }
        });
        if (nearestIndex === 0) {
          jumpToIndex(allSlides.length - 2);
          setActiveMedia(slides[slides.length - 1].dataset.mediaId);
          return;
        }
        if (nearestIndex === allSlides.length - 1) {
          jumpToIndex(1);
          setActiveMedia(slides[0].dataset.mediaId);
          return;
        }
        setActiveMedia(allSlides[nearestIndex].dataset.mediaId);
      };

      slider.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(settleLoop, 55);
      }, { passive: true });
    }

    // Minimal custom video player: centered play/pause button + a clean seek bar.
    const setVideoProgress = (control, percent) => {
      if (!control) return;
      const value = Math.max(0, Math.min(100, Number(percent || 0)));
      control.value = String(value);
      control.closest('[data-video-bar]')?.style.setProperty('--video-progress', `${value}%`);
    };

    section.addEventListener('click', e => {
      const toggle = e.target.closest('[data-video-toggle]');
      if (!toggle) return;
      e.preventDefault();
      e.stopPropagation();
      const wrap = toggle.closest('[data-product-video]');
      const video = wrap?.querySelector('video');
      if (!video) return;

      // Only one native product video should play at a time.
      section.querySelectorAll('[data-product-video] video').forEach(other => {
        if (other !== video && !other.paused) other.pause();
      });

      if (video.paused || video.ended) video.play().catch(() => {});
      else video.pause();
    });

    section.addEventListener('input', e => {
      const progress = e.target.closest('[data-video-progress]');
      if (!progress) return;
      e.stopPropagation();
      const video = progress.closest('[data-product-video]')?.querySelector('video');
      if (!video || !Number.isFinite(video.duration) || video.duration <= 0) return;
      video.currentTime = (Number(progress.value || 0) / 100) * video.duration;
      setVideoProgress(progress, progress.value);
    });

    section.addEventListener('click', e => {
      const toggle = e.target.closest('[data-external-video-toggle]');
      if (!toggle) return;
      e.preventDefault();
      e.stopPropagation();
      const wrap = toggle.closest('[data-product-external-video]');
      const iframe = wrap?.querySelector('iframe');
      const host = wrap?.dataset.videoHost;
      if (!iframe || !host) return;
      const playing = !toggle.classList.contains('is-playing');
      try {
        if (host === 'youtube') {
          iframe.contentWindow?.postMessage(JSON.stringify({ event: 'listening' }), '*');
          iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: playing ? 'playVideo' : 'pauseVideo', args: [] }), '*');
        } else if (host === 'vimeo') {
          iframe.contentWindow?.postMessage({ method: playing ? 'play' : 'pause' }, '*');
          iframe.contentWindow?.postMessage({ method: 'addEventListener', value: 'timeupdate' }, '*');
        }
      } catch (_) {}
      toggle.classList.toggle('is-playing', playing);
      toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
      toggle.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    });

    section.addEventListener('input', e => {
      const progress = e.target.closest('[data-external-video-progress]');
      if (!progress) return;
      e.stopPropagation();
      const wrap = progress.closest('[data-product-external-video]');
      const iframe = wrap?.querySelector('iframe');
      const host = wrap?.dataset.videoHost;
      const duration = Number(wrap?.dataset.videoDuration || 0);
      if (!iframe || !host || !duration) return;
      const seconds = (Number(progress.value || 0) / 100) * duration;
      try {
        if (host === 'youtube') iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'seekTo', args: [seconds, true] }), '*');
        else if (host === 'vimeo') iframe.contentWindow?.postMessage({ method: 'setCurrentTime', value: seconds }, '*');
      } catch (_) {}
      setVideoProgress(progress, progress.value);
    });

    section.querySelectorAll('[data-product-video] video').forEach(video => {
      const syncVideoUi = () => {
        const wrap = video.closest('[data-product-video]');
        const button = wrap?.querySelector('[data-video-toggle]');
        const progress = wrap?.querySelector('[data-video-progress]');
        if (button) {
          const playing = !video.paused && !video.ended;
          button.classList.toggle('is-playing', playing);
          button.setAttribute('aria-pressed', playing ? 'true' : 'false');
          button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
        }
        if (progress && Number.isFinite(video.duration) && video.duration > 0) setVideoProgress(progress, (video.currentTime / video.duration) * 100);
      };
      ['play', 'pause', 'ended', 'timeupdate', 'loadedmetadata', 'durationchange'].forEach(eventName => video.addEventListener(eventName, syncVideoUi));
      syncVideoUi();
    });

    const externalFrames = [...section.querySelectorAll('[data-product-external-video]')];
    const initialiseExternalFrame = wrap => {
      const iframe = wrap.querySelector('iframe');
      const host = wrap.dataset.videoHost;
      if (!iframe || !host) return;
      try {
        if (host === 'youtube') iframe.contentWindow?.postMessage(JSON.stringify({ event: 'listening' }), '*');
        else if (host === 'vimeo') {
          iframe.contentWindow?.postMessage({ method: 'addEventListener', value: 'timeupdate' }, '*');
          iframe.contentWindow?.postMessage({ method: 'getDuration' }, '*');
        }
      } catch (_) {}
    };
    externalFrames.forEach(wrap => {
      const iframe = wrap.querySelector('iframe');
      if (iframe) iframe.addEventListener('load', () => initialiseExternalFrame(wrap));
      initialiseExternalFrame(wrap);
    });

    window.addEventListener('message', event => {
      const wrap = externalFrames.find(item => item.querySelector('iframe')?.contentWindow === event.source);
      if (!wrap) return;
      let data = event.data;
      if (typeof data === 'string') { try { data = JSON.parse(data); } catch (_) { return; } }
      if (!data || typeof data !== 'object') return;
      const progress = wrap.querySelector('[data-external-video-progress]');
      const button = wrap.querySelector('[data-external-video-toggle]');
      const host = wrap.dataset.videoHost;

      if (host === 'vimeo') {
        if (data.event === 'timeupdate' && data.data) {
          const duration = Number(data.data.duration || wrap.dataset.videoDuration || 0);
          const seconds = Number(data.data.seconds || 0);
          if (duration > 0) { wrap.dataset.videoDuration = String(duration); setVideoProgress(progress, (seconds / duration) * 100); }
        } else if (data.method === 'getDuration' && Number(data.value) > 0) {
          wrap.dataset.videoDuration = String(Number(data.value));
        }
        return;
      }

      if (host === 'youtube') {
        const info = data.info || {};
        const duration = Number(info.duration || wrap.dataset.videoDuration || 0);
        const currentTime = Number(info.currentTime || 0);
        if (duration > 0) {
          wrap.dataset.videoDuration = String(duration);
          setVideoProgress(progress, (currentTime / duration) * 100);
        }
        if (Number.isFinite(info.playerState) && button) {
          const playing = info.playerState === 1;
          button.classList.toggle('is-playing', playing);
          button.setAttribute('aria-pressed', playing ? 'true' : 'false');
          button.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
        }
      }
    });

    const updateVariant = control => {
      if (!control) return;
      if (idInput) idInput.value = control.dataset.id || control.value;
      const p = control.dataset.price;
      const compare = control.dataset.compare;
      const saved = control.dataset.save;
      if (currentPrice && p) currentPrice.textContent = p;
      if (comparePrice) {
        comparePrice.textContent = compare || '';
        comparePrice.hidden = !compare;
      }
      if (savings && savingsAmount) {
        savingsAmount.textContent = saved || '';
        savings.hidden = !saved;
      }
      if (stickyPrice && p) stickyPrice.textContent = p;
      const available = control.dataset.available === 'true';
      if (add) {
        add.disabled = !available;
        const label = add.querySelector('[data-atc-label]');
        if (label) label.textContent = available ? add.dataset.availableText : add.dataset.soldoutText;
      }
      if (stickySubmit) {
        stickySubmit.disabled = !available;
        stickySubmit.textContent = available ? (stickySubmit.dataset.mobileAddLabel || 'Add') : (add?.dataset.soldoutText || 'Sold out');
      }
      section.querySelectorAll('[data-variant-pill]').forEach(x => x.classList.toggle('is-selected', x === control));
      if (history.replaceState) {
        const u = new URL(location.href);
        u.searchParams.set('variant', control.dataset.id || control.value);
        history.replaceState({}, '', u);
      }
      if (control.dataset.imageId) goToMedia(control.dataset.imageId);
    };

    section.querySelectorAll('[data-variant-pill]').forEach(btn => btn.addEventListener('click', () => updateVariant(btn)));
    const legacySelect = section.querySelector('[data-variant-select]');
    if (legacySelect) legacySelect.addEventListener('change', () => updateVariant(legacySelect.options[legacySelect.selectedIndex]));

    const sticky = section.querySelector('[data-sticky-atc]');
    const stickySubmit = section.querySelector('[data-sticky-submit]');
    if (sticky && add && 'IntersectionObserver' in window) {
      const atcObs = new IntersectionObserver(entries => entries.forEach(e => sticky.classList.toggle('is-visible', !e.isIntersecting)), { threshold: .1 });
      atcObs.observe(add);
    }
    if (stickySubmit && form) stickySubmit.addEventListener('click', () => { if (typeof form.requestSubmit === 'function') form.requestSubmit(add); else add.click(); });

    // Add to cart without leaving the page; open drawer immediately after success.
    if (form) {
      form.addEventListener('submit', async e => {
        if (!cartDrawer) return;
        if (!e.submitter || !e.submitter.matches('[data-add-to-cart]')) return;
        e.preventDefault();
        if (add) { add.classList.add('is-loading'); add.setAttribute('aria-busy', 'true'); }
        try {
          const response = await fetch(`${root}cart/add.js`, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
          if (!response.ok) {
            const err = await response.json().catch(() => ({}));
            throw new Error(err.description || 'Could not add item to cart');
          }
          if (cartDrawer) cartDrawer.classList.add('is-syncing');
          setCartOpen(true, false);
          await refreshCartDrawer();
          celebrateAddToCart();
          if (cartDrawer) cartDrawer.classList.remove('is-syncing');
          if (add) {
            const label = add.querySelector('[data-atc-label]');
            const original = label?.textContent;
            if (label) label.textContent = 'Added to cart';
            window.setTimeout(() => { if (label && original) label.textContent = original; }, 1400);
          }
        } catch (err) {
          alert(err.message || 'Could not add item to cart. Please try again.');
        } finally {
          if (add) { add.classList.remove('is-loading'); add.removeAttribute('aria-busy'); }
        }
      });
    }
  });

  // ---------- Similar products: always moves, but remains fully user-draggable ----------
  document.querySelectorAll('[data-similar-carousel]').forEach(viewport => {
    const firstSet = viewport.querySelector('.similar-products__set');
    if (!firstSet) return;

    let userInteracting = false;
    let resumeTimer = null;
    let last = performance.now();
    let dragging = false;
    let dragStartX = 0;
    let dragStartScroll = 0;
    let firstSetWidth = 0;
    let animationFrame = 0;
    const speed = viewport.classList.contains('featured-v8__viewport') ? 30 : 34; // smooth continuous commerce rail
    const desktopMotion = window.matchMedia('(min-width: 641px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let inViewport = true;

    const refreshSetWidth = () => { firstSetWidth = firstSet.offsetWidth; };
    refreshSetWidth();
    if ('ResizeObserver' in window) {
      const railResizeObserver = new ResizeObserver(refreshSetWidth);
      railResizeObserver.observe(firstSet);
    } else {
      let widthRefreshFrame = 0;
      window.addEventListener('resize', () => {
        if (widthRefreshFrame) return;
        widthRefreshFrame = requestAnimationFrame(() => { widthRefreshFrame = 0; refreshSetWidth(); });
      }, { passive: true });
    }

    const normalize = () => {
      const width = firstSetWidth || firstSet.offsetWidth;
      if (!width) return;
      if (viewport.scrollLeft >= width) viewport.scrollLeft -= width;
      if (viewport.scrollLeft < 0) viewport.scrollLeft += width;
    };
    viewport.addEventListener('scroll', normalize, { passive: true });

    const shouldAutoMove = () => inViewport && desktopMotion.matches && !reducedMotion.matches && !userInteracting && !dragging && !document.hidden;
    const stopAutoMove = () => {
      if (!animationFrame) return;
      cancelAnimationFrame(animationFrame);
      animationFrame = 0;
    };
    const tick = now => {
      animationFrame = 0;
      if (!shouldAutoMove()) return;
      const dt = Math.min((now - last) / 1000, .05);
      last = now;
      viewport.scrollLeft += speed * dt;
      normalize();
      animationFrame = requestAnimationFrame(tick);
    };
    const startAutoMove = () => {
      if (animationFrame || !shouldAutoMove()) return;
      last = performance.now();
      animationFrame = requestAnimationFrame(tick);
    };
    const syncAutoMove = () => { if (shouldAutoMove()) startAutoMove(); else stopAutoMove(); };

    if ('IntersectionObserver' in window) {
      const visibilityObserver = new IntersectionObserver(entries => {
        inViewport = !!entries[0]?.isIntersecting;
        syncAutoMove();
      }, { rootMargin: '160px 0px' });
      visibilityObserver.observe(viewport);
    }

    const pauseForUser = (delay = 850) => {
      userInteracting = true;
      stopAutoMove();
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => {
        userInteracting = false;
        startAutoMove();
      }, delay);
    };

    // Native touch scrolling stays enabled on phones/tablets.
    viewport.addEventListener('touchstart', () => pauseForUser(520), { passive: true });
    viewport.addEventListener('touchend', () => pauseForUser(240), { passive: true });
    viewport.addEventListener('wheel', () => pauseForUser(500), { passive: true });

    // Mouse / trackpad drag support for desktop.
    viewport.addEventListener('pointerdown', e => {
      if (e.pointerType === 'touch') return;
      dragging = true;
      dragStartX = e.clientX;
      dragStartScroll = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture?.(e.pointerId);
      pauseForUser(1500);
    });
    viewport.addEventListener('pointermove', e => {
      if (!dragging) return;
      viewport.scrollLeft = dragStartScroll - (e.clientX - dragStartX);
      pauseForUser(1000);
    });
    const endDrag = e => {
      if (!dragging) return;
      dragging = false;
      viewport.classList.remove('is-dragging');
      try { viewport.releasePointerCapture?.(e.pointerId); } catch (_) {}
      pauseForUser(240);
    };
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);

    const watchMotionPreference = query => {
      if (query.addEventListener) query.addEventListener('change', syncAutoMove);
      else query.addListener?.(syncAutoMove);
    };
    document.addEventListener('visibilitychange', syncAutoMove);
    watchMotionPreference(desktopMotion);
    watchMotionPreference(reducedMotion);
    startAutoMove();
  });


  // ---------- Expand/collapse the full iPhone collection list without changing routes ----------
  document.querySelectorAll('[data-phone-expand]').forEach(section => {
    const wrap = section.querySelector('[data-phone-reveal-wrap]');
    const grid = section.querySelector('[data-phone-reveal-grid]');
    const extras = [...section.querySelectorAll('[data-phone-extra]')];
    const button = section.querySelector('[data-phone-show-more]');
    const fade = section.querySelector('[data-phone-fade]');
    if (!wrap || !grid || !button || !extras.length) return;

    const cards = [...grid.querySelectorAll('.phone-choice')];
    const firstExtra = cards.findIndex(card => card.hasAttribute('data-phone-extra'));
    const defaultLabel = button.querySelector('[data-phone-show-label]')?.textContent || 'View more iPhone models';
    let expanded = false;

    const collapsedHeight = () => {
      if (firstExtra < 1) return grid.scrollHeight;
      const lastVisible = cards[firstExtra - 1];
      const firstHidden = cards[firstExtra];
      const visibleBottom = lastVisible.offsetTop + lastVisible.offsetHeight;
      const glimpse = firstHidden ? Math.min(74, firstHidden.offsetHeight * .38) : 0;
      return visibleBottom + glimpse;
    };

    const apply = () => {
      section.classList.toggle('is-expanded', expanded);
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      const label = button.querySelector('[data-phone-show-label]');
      const kicker = button.querySelector('[data-phone-show-kicker]');
      if (label) label.textContent = expanded ? 'View fewer iPhone models' : defaultLabel;
      if (kicker) kicker.textContent = expanded ? 'Tap to collapse the model list' : 'Scroll down to see all available models';
      wrap.style.maxHeight = `${expanded ? grid.scrollHeight : collapsedHeight()}px`;
      if (fade) fade.hidden = expanded;
    };

    requestAnimationFrame(() => requestAnimationFrame(apply));
    let resizeFrame = 0;
    window.addEventListener('resize', () => {
      if (resizeFrame) return;
      resizeFrame = requestAnimationFrame(() => { resizeFrame = 0; apply(); });
    }, { passive: true });
    button.addEventListener('click', () => { expanded = !expanded; apply(); });
  });

  // ---------- Collection return position + infinite scroll ----------
  // The collection is an endless AJAX-loaded page. Browsers can lose that exact
  // position after visiting a product because the dynamically loaded cards may not
  // exist yet when Back is pressed. Save the clicked card + scroll point, rebuild
  // enough of the endless grid, then put the shopper back in the same place.
  const COLLECTION_RETURN_STORAGE_KEY = '321-mobile:collection-return:v1';

  const collectionLocationKey = () => {
    const url = new URL(location.href);
    url.searchParams.delete('page');
    return `${url.pathname}${url.search}`;
  };

  const saveCollectionReturnPosition = link => {
    const grid = document.querySelector('[data-infinite-grid]');
    if (!grid || !link) return;
    const card = link.closest('.product-card');
    const cards = [...grid.querySelectorAll('.product-card')];
    let productPath = '';
    try { productPath = new URL(link.href, location.href).pathname; } catch (_) {}

    const state = {
      pending: true,
      collectionKey: collectionLocationKey(),
      scrollY: Math.max(0, Math.round(window.scrollY || 0)),
      cardCount: cards.length,
      cardIndex: card ? cards.indexOf(card) : -1,
      cardViewportTop: card ? Math.round(card.getBoundingClientRect().top) : null,
      productPath,
      savedAt: Date.now()
    };
    try { sessionStorage.setItem(COLLECTION_RETURN_STORAGE_KEY, JSON.stringify(state)); } catch (_) {}
  };

  // Delegation also covers product cards that were appended by infinite scroll.
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('[data-infinite-grid] .product-card a[href]');
    if (!link || link.target === '_blank') return;
    let url;
    try { url = new URL(link.href, location.href); } catch (_) { return; }
    if (url.origin !== location.origin || !/\/products\//.test(url.pathname)) return;
    saveCollectionReturnPosition(link);
  }, true);

  const initInfiniteCollection = () => {
    const grid = document.querySelector('[data-infinite-grid]');
    const sentinel = document.querySelector('[data-infinite-scroll]');
    if (!grid || !sentinel) return null;

    let loadingPromise = null;
    let observer = null;
    const loadedPageUrls = new Set();

    // Shopify products are unique by ID. Keep a client-side guard as well because
    // mobile in-app browsers/bfcache can restore an already-appended grid while an
    // old infinite-scroll request is still eligible to run.
    const productKey = card => {
      const id = card?.dataset?.productId;
      if (id) return `id:${id}`;
      const handle = card?.dataset?.productHandle;
      if (handle) return `handle:${handle}`;
      const link = card?.querySelector('a[href*="/products/"]');
      if (!link) return '';
      try { return `path:${new URL(link.href, location.href).pathname}`; } catch (_) { return ''; }
    };

    const removeDuplicateCards = () => {
      const seen = new Set();
      [...grid.querySelectorAll('.product-card')].forEach(card => {
        const key = productKey(card);
        if (!key) return;
        if (seen.has(key)) card.remove();
        else seen.add(key);
      });
      return seen;
    };

    removeDuplicateCards();

    const hasNext = () => Boolean(sentinel.dataset.nextUrl) && !sentinel.classList.contains('is-complete');

    const loadNext = async () => {
      const nextUrl = sentinel.dataset.nextUrl;
      if (!nextUrl || sentinel.classList.contains('is-complete')) return false;
      if (loadingPromise) return loadingPromise;

      let pageKey;
      try { pageKey = new URL(nextUrl, location.href).href; } catch (_) { pageKey = nextUrl; }
      if (loadedPageUrls.has(pageKey)) {
        sentinel.classList.add('is-complete');
        observer?.disconnect();
        return false;
      }
      loadedPageUrls.add(pageKey);

      loadingPromise = (async () => {
        sentinel.classList.add('is-loading');
        try {
          const response = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error('Could not load more products');
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const nextGrid = doc.querySelector('[data-infinite-grid]');
          const nextSentinel = doc.querySelector('[data-infinite-scroll]');
          if (!nextGrid) throw new Error('Next product grid missing');

          const seen = removeDuplicateCards();
          const fragment = document.createDocumentFragment();
          [...nextGrid.querySelectorAll(':scope > .product-card')].forEach(card => {
            const key = productKey(card);
            if (key && seen.has(key)) return;
            if (key) seen.add(key);
            fragment.appendChild(card);
          });
          grid.appendChild(fragment);

          const followingUrl = nextSentinel?.dataset.nextUrl || '';
          sentinel.dataset.nextUrl = followingUrl;
          sentinel.classList.remove('has-error');
          const statusText = sentinel.querySelector('.collection-infinite-scroll__text');
          if (statusText) statusText.textContent = 'Loading more products…';
          if (!followingUrl) {
            sentinel.classList.add('is-complete');
            observer?.disconnect();
          }
          return true;
        } catch (err) {
          loadedPageUrls.delete(pageKey);
          console.warn(err);
          sentinel.classList.add('has-error');
          const text = sentinel.querySelector('.collection-infinite-scroll__text');
          if (text) text.textContent = 'Scroll a little more to retry';
          return false;
        } finally {
          sentinel.classList.remove('is-loading');
          loadingPromise = null;
        }
      })();

      return loadingPromise;
    };

    sentinel.addEventListener('click', () => { if (sentinel.classList.contains('has-error')) loadNext(); });

    if ('IntersectionObserver' in window && hasNext()) {
      observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) loadNext();
      }, { rootMargin: '700px 0px 700px 0px' });
      observer.observe(sentinel);
    } else if (!('IntersectionObserver' in window) && hasNext()) {
      const onScroll = () => {
        if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 900) loadNext();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    return { grid, sentinel, loadNext, hasNext };
  };

  const infiniteCollection = initInfiniteCollection();
  let collectionRestoreInProgress = false;

  const restoreCollectionReturnPosition = async () => {
    if (!infiniteCollection || collectionRestoreInProgress) return;

    let state;
    try { state = JSON.parse(sessionStorage.getItem(COLLECTION_RETURN_STORAGE_KEY) || 'null'); } catch (_) { return; }
    if (!state?.pending || state.collectionKey !== collectionLocationKey()) return;

    // Do not revive a stale shopping position from an old browsing session.
    if (!state.savedAt || Date.now() - Number(state.savedAt) > 2 * 60 * 60 * 1000) {
      try { sessionStorage.removeItem(COLLECTION_RETURN_STORAGE_KEY); } catch (_) {}
      return;
    }

    collectionRestoreInProgress = true;
    try {
      // If the page was rebuilt instead of restored from bfcache, reload every AJAX
      // page that existed when the product was opened before attempting to scroll.
      let attempts = 0;
      const requiredCards = Math.max(0, Number(state.cardCount || 0));
      const requiredBottom = Math.max(0, Number(state.scrollY || 0)) + window.innerHeight + 120;
      while (
        infiniteCollection.hasNext() &&
        attempts < 30 &&
        (infiniteCollection.grid.querySelectorAll('.product-card').length < requiredCards || document.documentElement.scrollHeight < requiredBottom)
      ) {
        attempts += 1;
        const loaded = await infiniteCollection.loadNext();
        if (!loaded) break;
      }

      // Let image aspect-ratios/layout settle. Then anchor to the same product card
      // if possible; the saved raw Y position is the fallback.
      await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));

      let targetY = Math.max(0, Number(state.scrollY || 0));
      let card = null;
      if (state.productPath) {
        card = [...infiniteCollection.grid.querySelectorAll('.product-card')].find(item => {
          const productLink = item.querySelector('a[href]');
          if (!productLink) return false;
          try { return new URL(productLink.href, location.href).pathname === state.productPath; } catch (_) { return false; }
        });
      }
      if (!card && Number(state.cardIndex) >= 0) {
        card = infiniteCollection.grid.querySelectorAll('.product-card')[Number(state.cardIndex)] || null;
      }
      if (card && Number.isFinite(Number(state.cardViewportTop))) {
        targetY = Math.max(0, window.scrollY + card.getBoundingClientRect().top - Number(state.cardViewportTop));
      }

      window.scrollTo({ top: targetY, left: 0, behavior: 'auto' });
      // A second correction handles late font/image settling on mobile in-app browsers.
      requestAnimationFrame(() => window.scrollTo({ top: targetY, left: 0, behavior: 'auto' }));

      state.pending = false;
      state.restoredAt = Date.now();
      try { sessionStorage.setItem(COLLECTION_RETURN_STORAGE_KEY, JSON.stringify(state)); } catch (_) {}
    } finally {
      collectionRestoreInProgress = false;
    }
  };

  // Fresh back navigations and Safari/Instagram bfcache returns are both covered.
  window.addEventListener('pageshow', restoreCollectionReturnPosition);
  restoreCollectionReturnPosition();

  const sort = document.querySelector('[data-sort-by]');
  if (sort) sort.addEventListener('change', () => {
    const url = new URL(location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    location.href = url.toString();
  });
});



// V10.5 — full cart page updates automatically with Shopify AJAX.
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let cartPageBusy = false;
  let inputTimer = null;

  const refreshFullCartSection = async (cartJson) => {
    const current = document.querySelector('.cart-page');
    if (!current) return;
    current.classList.add('is-cart-refreshing');
    try {
      const response = await fetch(`${root}cart?section_id=main-cart-321`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('Could not refresh cart');
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('.cart-page');
      if (!next) throw new Error('Cart section missing');
      current.replaceWith(next);
      const count = Number(cartJson?.item_count || 0);
      document.querySelectorAll('[data-cart-count], [data-cart-drawer-count]').forEach(el => {
        el.textContent = count;
        if (el.matches('[data-cart-count]')) el.classList.toggle('is-empty', count === 0);
      });
    } catch (err) {
      console.warn(err);
      location.reload();
    }
  };

  const updateCartLine = async (line, quantity) => {
    if (!line || cartPageBusy) return;
    const key = line.dataset.cartKey;
    if (!key) return;
    cartPageBusy = true;
    line.classList.add('is-updating');
    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, Number(quantity) || 0) })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'Could not update cart');
      await refreshFullCartSection(cart);
    } catch (err) {
      line.classList.remove('is-updating');
      alert(err.message || 'Could not update your cart. Please try again.');
    } finally {
      cartPageBusy = false;
    }
  };

  document.addEventListener('click', e => {
    const line = e.target.closest('[data-cart-page-line]');
    if (!line) return;
    const remove = e.target.closest('[data-cart-page-remove]');
    if (remove) {
      e.preventDefault();
      updateCartLine(line, 0);
      return;
    }
    const step = e.target.closest('[data-cart-page-step]');
    if (!step) return;
    e.preventDefault();
    const input = line.querySelector('[data-cart-page-input]');
    if (!input) return;
    const delta = parseInt(step.dataset.cartPageStep || '0', 10) || 0;
    const next = Math.max(0, (parseInt(input.value || '0', 10) || 0) + delta);
    input.value = next;
    updateCartLine(line, next);
  });

  document.addEventListener('input', e => {
    const input = e.target.closest('[data-cart-page-input]');
    if (!input) return;
    const line = input.closest('[data-cart-page-line]');
    if (!line) return;
    clearTimeout(inputTimer);
    inputTimer = setTimeout(() => updateCartLine(line, Math.max(0, parseInt(input.value || '0', 10) || 0)), 450);
  });
})();
